import { render, staticRenderFns } from "./DepartamentosEditar.vue?vue&type=template&id=436255fb&"
import script from "./DepartamentosEditar.vue?vue&type=script&lang=js&"
export * from "./DepartamentosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports